import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {toast} from 'react-toastify';
import App from '@app/App';
import store from '@store';
import {BrowserRouter} from 'react-router-dom';
import { PhotoProvider } from 'react-photo-view';
import ModalProvider from 'react-redux-modal-provider';

import './index.scss';
import './i18n';
import SocketProvider  from '@app/context/SocketContext';
import * as serviceWorker from './serviceWorker';

toast.configure({
    autoClose: 3000,
    draggable: false,
    position: 'top-right',
    hideProgressBar: false,
    newestOnTop: true,
    closeOnClick: true,
    rtl: false,
    pauseOnVisibilityChange: true,
    pauseOnHover: true
});

ReactDOM.render(
    <PhotoProvider>
        <Provider store={store}>
            <SocketProvider>
                <BrowserRouter>
                    <App />
                    <ModalProvider />
                </BrowserRouter>
            </SocketProvider>
        </Provider>
    </PhotoProvider>

    ,
    document.getElementById('root')
);



// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
